import router from "/src/router";
function isMobileDevice() {
  const userAgent = navigator.userAgent.toLowerCase();
  return /android|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|windows phone|phone|webos|kindle|tablet/i.test(userAgent);
}
(function (doc, win) {
  if (!doc.addEventListener) return;
  var docEl = doc.documentElement;
  var resizeEvt = "orientationchange" in window ? "orientationchange" : "resize";
  var recalc = function () {
    var clientWidth = docEl.clientWidth;
    if (!clientWidth) return;
    var routeStr = router.currentRoute._rawValue.path;
    var queryStr = router.currentRoute._rawValue.query.type;
    if (isMobileDevice() || clientWidth <= 750) {
      docEl.style.fontSize = (clientWidth / 750) * 100 + "px";
      if (routeStr == "/") {
        router.replace("/mobileHome");
      } else if (routeStr == "/about") {
        router.replace("/mobileAbout");
      } else if (routeStr == "/bestSellingStar") {
        router.replace("/mobileBestSellingStar");
      } else if (routeStr == "/product") {
        router.replace({ name: "MobileProduct", query: { type: queryStr } });
      } else if (routeStr == "/contactUs") {
        router.replace("/mobileContactUs");
      } else if (routeStr == "/termsOfUse") {
        router.replace("/mobileTermsOfUse");
      }
    } else {
      clientWidth = clientWidth <= 1370 ? clientWidth : 1370;
      docEl.style.fontSize = (clientWidth / 1920) * 100 + "px";
      if (routeStr == "/mobileHome") {
        router.replace("/");
      } else if (routeStr == "/mobileAbout") {
        router.replace("/about");
      } else if (routeStr == "/mobileBestSellingStar") {
        router.replace("/bestSellingStar");
      } else if (routeStr == "/mobileProduct") {
        router.replace({ name: "Product", query: { type: queryStr } });
      } else if (routeStr == "/mobileContactUs") {
        router.replace("/contactUs");
      } else if (routeStr == "/mobileTermsOfUse") {
        router.replace("/termsOfUse")
      }
    }
  };
  win.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener("DOMContentLoaded", recalc, false);
})(document, window);
